import {arrayShuffle} from '../../../../lib/helpers';
import {MQDataPairState, MQMatchingQuestion, MQMatchingQuestionState} from './models';

function initialState(mq: MQMatchingQuestion): MQMatchingQuestionState {
  const rightSideOrder = mq.dataPairs.map((_, index) => index);
  arrayShuffle(rightSideOrder);

  const dataPairStates = mq.dataPairs
    .map((x, index): MQDataPairState => {
      if (x.fixed)
        return {matchedTo: index, checked: true};
      return {matchedTo: null, checked: false};
    });

  return {
    RightSideOrder: rightSideOrder,
    DataPairStates: dataPairStates
  };
}

class MatchingQuestionUtilsClass {
  readonly initialState = initialState;
}

export const matchingQuestionUtils = new MatchingQuestionUtilsClass();
